import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// AppSetUp - Get All (Read)
export const GetAll = createAsyncThunk(
  "ManagePickupDrop/assigned-entry",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ManagePickupDropAdmin.AssignedEntry}?email=${filter?.email ||
          ""}&vehicleNo=${filter?.vehicleNo || ""}&from=${filter?.from ||
          ""}&to=${filter?.to || ""}&todayFilter=${filter?.todayFilter ||
          ""}&service_type_id=${filter?.service_type_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const canceltrip = createAsyncThunk(
  "ManagePickupDrop/assigned-entry/cancel-trip",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.ManagePickupDropAdmin.AssignedEntry}/cancel-trip/${id}`,
        { cancel_reason: data }
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const assignAmbassadorNew = createAsyncThunk(
  "ManagePickupDrop/assigned-entry/assign-ambassador",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.ManagePickupDropAdmin.AssignedEntry}/${id}`,
        {
          ambassador_id: data,
        }
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "assigned-entry",
  initialState: {
    data: null, // Store single record
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GetAll
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(canceltrip.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(canceltrip.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
        // const index = state.data.findIndex(
        //   (category) => category.id === action.payload?.data?.id
        // );
        // if (index !== -1) {
        //   state.data[index] = action.payload.data;
        // }
      })
      .addCase(canceltrip.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(assignAmbassadorNew.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(assignAmbassadorNew.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
      })
      .addCase(assignAmbassadorNew.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
